import React, { useContext, useState, useEffect } from "react";
import {withRouter} from 'react-router-dom';
import { css } from "emotion";
import { BuildContext } from "../../context/BuildSpotlightState";
import Section from "../createNew/Section";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import GenericTextInput from "../GenericTextInput";
import GenericButton from "../GenericButton";
import spotlights from "../../services/api/spotlights";
import { GlobalContext } from "../../context/GlobalState";
import TitleBlock from "./TitleBlock";
import PublishWithAdvancedOptionsLink from "../targeting/PublishWithAdvancedOptionsLink";

const SaveSpotlight = ({ history }) => {
  const {
    name,
    setName,
    type,
    headline,
    ctaText,
    ctaUrl,
    primaryColor,
    secondaryColor,
    fileName,
    fileUrl,
    pages,
    utm_source,
    utm_medium,
    utm_content,
    utm_term,
    utm_campaign,
    queryParameters,
  } = useContext(BuildContext);

  const { currentWorkspace } = useContext(GlobalContext);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);

  const validateSpotlight = () => {
    if (!name) {
      setError("Make sure to give your spotlight a name!");
      return false;
    } else if (!type) {
      setError("There is no type associated with this spotlight...");
      return false;
    } else if (!headline) {
      setError("There is no headline associated with this spotlight...");
      return false;
    } else if (!primaryColor || !secondaryColor) {
      setError("There is no color settings associated with this spotlight...");
      return false;
    } else if (!fileName && type === "audio") {
      setError("There is no audio file associated with this spotlight...");
      return false;
    } else {
      setError("");
      return true;
    }
  };

  const handleAction = async (e, goLive) => {
    e.preventDefault();
    if (validateSpotlight()) {
      const spotlightData = {
        type,
        name,
        headline,
        ctaText,
        ctaUrl,
        fileUrl,
        fileName,
        primaryColor,
        secondaryColor,
        workspace: currentWorkspace.id,
        isActive: goLive,
        pages,
        utm_source,
        utm_medium,
        utm_content,
        utm_term,
        utm_campaign,
        queryParameters
      };

      try {
        await spotlights.create(spotlightData);
        history.push("/home");
      } catch (error) {
        console.log(error);
      }
    } else {
      return;
    }
  };

  useEffect(() => {
    setDisabled(!validateSpotlight());
  }, [name]);

  return (
    <form className={container} onSubmit={(e) => handleAction(e, true)}>
      <TitleBlock/>
      <Section heading="Spotlight Name">
        <GenericTextInput
          placeholder="Input text here"
          value={name}
          onValueChange={setName}
          maxLength={60}
        />
      </Section>
      <div className="break"/>
      <div className="buttonRow">
        <GenericButton text="Publish As Default Spotlight" style="default-btn" disabled={disabled} />
        <p>or</p>
        <PublishWithAdvancedOptionsLink disabled={disabled}/>
      </div>
      {error && (
        <div className="errorBox">
          <p>{error}</p>
        </div>
      )}
    </form>
  );
};

export default withRouter(SaveSpotlight);

const container = css`
  padding: ${boxStyles.standardPadding};
  max-width: 500px;

  .break {
    background-color: ${colors.lineBreak};
    height: 1px;
    margin-top: 15px;
  }
  
  .options-container {
    margin-top: 40px;
  }

  .buttonRow {
    margin-top: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    
    >p {
      margin-top: 15px;
      margin-bottom: 15px;
      color: ${colors.subtitleColor};
      text-transform: uppercase;
      font-weight: 500;
      font-size: 12px;
    }
  }

  .errorBox {
    padding: ${boxStyles.standardPadding} 0;
    p {
      font-size: ${textSizes.normal};
      color: ${colors.cancel};
      text-align: center;
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    width: 60%;
    margin: auto;
  }
`;
